import { AbstractControl, ValidationErrors } from "@angular/forms";

export function int32Validator(control: AbstractControl): ValidationErrors | null {
  if (control.value == null || control.value === "") {
    return null;
  }

  const value = control.value;
  return Number.isInteger(value) && value >= -2147483648 && value <= 2147483647 ? null : { int32: true };
}
